import { isMobileAppPlatform } from './isMobileAppPlatform';
import { navigateTo, openInNewTab } from './navigation';

// Hand off to a partner URL, branching on the platform query param. The native
// iOS/Android in-app browser has no "new tab" concept, so a `window.open`
// either silently drops or prompts the user to leave the host app; on those
// clients we navigate the same view instead. Web continues to open a new tab.
export const openOrNavigate = (
  url: string,
  platform: string | string[] | undefined,
) => {
  if (isMobileAppPlatform(platform)) {
    navigateTo(url);
    return;
  }
  openInNewTab(url);
};
